import { render, staticRenderFns } from "./SetCookie.vue?vue&type=template&id=aba49c66&scoped=true&"
import script from "./SetCookie.vue?vue&type=script&lang=js&"
export * from "./SetCookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba49c66",
  null
  
)

export default component.exports